'use client'

import React, { useEffect } from 'react'
import { atom, useRecoilState, useRecoilValue } from 'recoil'

import { browserIdState } from '@/components/Context/BrowserProvider'
import { getCart } from '@/serverActions/getCart'
import { CartType } from '@/types/cart'

export const cartState = atom<CartType | null>({
  key: 'cart',
  default: null,
})

export default function CartProvider({ children }: { children: React.ReactNode }) {
  return (
    <>
      <GetCart />
      {children}
    </>
  )
}

const GetCart = () => {
  const browserId = useRecoilValue(browserIdState)
  const [cart, setCart] = useRecoilState(cartState)
  useEffect(() => {
    ;(async () => {
      if (cart !== null || browserId == null) return
      setCart(await getCart())
    })()
  }, [browserId])
  return <></>
}
